import { usePostContentContext } from '@/postContentElement/context';
import { embedTitleContainer, embedTitleParagraph } from './GenericEmbedTitle.css';
import type { TPostGenericEmbedTitleProps } from './GenericEmbedTitle.types';

export const PostGenericEmbedTitle = ({ element }: TPostGenericEmbedTitleProps) => {
  const { postTheme } = usePostContentContext();

  if (!element?.content?.[0]?.text || postTheme?.hyperlink_hide_title === 'true') {
    return null;
  }

  return (
    <div className={embedTitleContainer}>
      <p className={embedTitleParagraph}>{element.content[0].text}</p>
    </div>
  );
};
